import Axios from 'axios';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import 'react-perfect-scrollbar/dist/css/styles.css';
import { toast } from 'react-toastify';
import { Button, Col, Row } from 'reactstrap';
import Breadcrumb from '../../../components/common/breadcrumb';
import { goRiceUrl } from '../../../constant/siteConstants';
import { ButtonOnExporting } from '../../../utils/DataGridExporter';
import useFormatMessage from '../../../utils/useFormatMessage';
import EmployeeAddModal from '../components/KullaniciYonetimi/EmployeeAddModal';
import EmployeeTable from '../components/KullaniciYonetimi/EmployeeTable';

export default function KullaniciYonetimi() {
    const { t } = useFormatMessage();

    const notifyError = (message) => toast.error(`${message}`);
    const [employeeAddModal, setEmployeeAddModal] = useState(false);
    const [employeeDatas, setEmployeeDatas] = useState([]);
    const [trigger, setTrigger] = useState(true);

    async function getEmployeeDatas() {
        // TODO: Enes Api
        let token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlX21haWwiOiJtZWxpa2VAZGlhdGljcy5jb20iLCJlbXBsb3llZV9pZCI6MzE4NTY3LCJleHAiOjUzMjk2NjM4NDIsImZ1bGxfbmFtZSI6Ik1lbGlrZSDDlnpsZW0ifQ.UFI_pVDY7igCUpgfQCIqO8t3_WjUUldDBYorDRkNgaQ"

        await Axios.post(`${goRiceUrl}/api/employee/getAll`, {}, {
            headers: {
                token: `${token}`,
            }
        }).then((resp) => {
            setEmployeeDatas(resp.data);

        }).catch((err) => {
            console.error(err);
            notifyError("Kullanıcı bilgileri yüklenirken bir servis hatası meydana geldi.");
        })
    }
    /* eslint-disable react-hooks/exhaustive-deps */
    useEffect(() => {
        getEmployeeDatas();
    }, [trigger])
    /* eslint-disable react-hooks/exhaustive-deps */

    const dataGridRef = useRef();


    return (
        <>
            <Breadcrumb current={t("Kullanıcı Yönetimi")} />
            <div className='card mb-4 p-4'>
                <Row className='mb-3'>
                    <Col xl="12" className='d-flex justify-content-end' style={{ gap: "5px" }}>
                        <Button onClick={() => setEmployeeAddModal(true)}>{t("Yeni Kayıt")}</Button>
                        <Button className='btn-success' style={{ padding: "6px 10px", cursor: "pointer" }} onClick={(e) => { ButtonOnExporting(e, dataGridRef, `Sayfa-1 ${moment(new Date()).format("DD/MM/YYYY")}`, "Revizyon 1") }}>
                            <i className='fa fa-file-excel-o' style={{ color: "white" }}></i>
                        </Button>
                    </Col>
                </Row>
                <Row>
                    <Col xl="12">
                        <EmployeeTable dataGridRef={dataGridRef} dataSource={employeeDatas} trigger={trigger} setTrigger={setTrigger} />
                        <EmployeeAddModal trigger={trigger} setTrigger={setTrigger} employeeAddModal={employeeAddModal} setEmployeeAddModal={setEmployeeAddModal} />
                    </Col>
                </Row>
            </div>
        </>
    )
}

